import React from "react";
import { Button, Form } from "react-bootstrap";
import StatusFilter from "./StatusFilter";
import SearchFilter from "./SearchFilter";
import UserTypeFilter from "./UserTypeFilter";

const Filter = ({
	statusFilterOptionArr,
	setBody,
	body,
	searchHandler,
	setBodyFilter,
	bytext,
	filterType = "status",
	searchFilterOptionArr = []
}) => {
	const clearFilters = (e) => {
		setBody({
			...body,
			[filterType]: e.target.value,
			search: "",
		});

		if ((searchHandler, setBodyFilter)) {
			searchHandler("");
			setBodyFilter("");
		}
	};

	console.log("dsss",body.filter)
	return (
		<ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
			<li className="d-flex align-items-center gap-10">
				{statusFilterOptionArr?.length&&<label
					htmlFor=""
					className="form-label m-0 fw-sbold text-muted"
					style={{ whiteSpace: "nowrap" }}
				>
					Filter by {bytext || "Status"}
				</label>}
				{statusFilterOptionArr?.length&&(filterType === "status") ?
					<StatusFilter
						body={body}
						setBody={setBody}
						statusFilterOptionArr={statusFilterOptionArr}
					/> :
					statusFilterOptionArr?.length&&<UserTypeFilter
						body={body}
						setBody={setBody}
						userTypeFilterOptionArr={statusFilterOptionArr}
						filterType={filterType}
					/>
				}
			</li>
			<li className="">
				{
					body?.filter && body?.filter != "all" ?

						<Form.Select
							className="select text-muted"
							aria-label="Default select example"
							defaultValue={body[body.filter]}
							value={body[body.filter]}
							onChange={(e) =>
								setBody((p) => ({
									...p,
									[body.filter]: e.target.value,
								}))
							}
						>
							{searchFilterOptionArr?.map((option) => {
								return (
									<option value={option.value}>{option.label}</option>
								)
							})}

						</Form.Select>
						:
						body?.filter != "all" ?
							<SearchFilter
								body={body}
								setBody={setBody}
								searchHandler={searchHandler}
							/>
							:
							<></>
				}
			</li>
			{!body?.filter ?
				<li className="ml-2">
					<Button variant="secondary" onClick={clearFilters}>
						Clear
					</Button>
				</li>
				:
				<></>
			}
		</ul>
	);
};

export default Filter;
